/* コンテナ関連 */
.container {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 1rem;
}

.pageContainer {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1rem;
}

/* 見出し関連 */
.title {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #333;
}

.subtitle {
  font-size: 1rem;
  color: #666;
  margin-bottom: 0.5rem;
}

/* レスポンシブ */
@media (max-width: 600px) {
  .container {
    padding: 0.5rem;
  }
  
  .title {
    font-size: 1.25rem;
  }
  
  .subtitle {
    font-size: 0.9rem;
  }
} 